webpackJsonp([17],{

/***/ 135:
/*!***************************************!*\
  !*** ./src/components/ColorBadge.vue ***!
  \***************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ColorBadge_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ColorBadge.vue */ 385);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3df2c514_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ColorBadge_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3df2c514","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ColorBadge.vue */ 697);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-3df2c514","scoped":false,"hasInlineConfig":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ColorBadge.vue */ 696)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ColorBadge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3df2c514_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ColorBadge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 142:
/*!***************************************!*\
  !*** ./src/components/OptionHtml.vue ***!
  \***************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_OptionHtml_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./OptionHtml.vue */ 387);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22de0688_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OptionHtml_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-22de0688","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./OptionHtml.vue */ 703);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_OptionHtml_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22de0688_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OptionHtml_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 143:
/*!********************************!*\
  !*** ./src/components/App.vue ***!
  \********************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue */ 144);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eb13c0c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-2eb13c0c","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue */ 443);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-2eb13c0c","scoped":false,"hasInlineConfig":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./App.vue */ 427)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eb13c0c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 144:
/*!***************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/App.vue ***!
  \***************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_package_common_vuejs_src_layouts_AppLayout__ = __webpack_require__(/*! package-common-vuejs/src/layouts/AppLayout */ 428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_app_mixin__ = __webpack_require__(/*! ../mixins/app-mixin */ 78);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_app_mixin__["a" /* AppMixin */]],
  components: {
    AppLayout: __WEBPACK_IMPORTED_MODULE_0_package_common_vuejs_src_layouts_AppLayout__["a" /* default */]
  }
});

/***/ }),

/***/ 296:
/*!*******************************************!*\
  !*** ./src/components/LayoutSignedIn.vue ***!
  \*******************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_LayoutSignedIn_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./LayoutSignedIn.vue */ 297);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d533bf0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayoutSignedIn_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-2d533bf0","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./LayoutSignedIn.vue */ 552);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_LayoutSignedIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d533bf0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayoutSignedIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 297:
/*!**************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LayoutSignedIn.vue ***!
  \**************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/asyncToGenerator */ 75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/taggedTemplateLiteral */ 95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(/*! graphql-tag */ 59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_app_mixin__ = __webpack_require__(/*! ../mixins/app-mixin */ 78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_package_common_vuejs_src_layouts_StandardLayout__ = __webpack_require__(/*! package-common-vuejs/src/layouts/StandardLayout */ 540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_package_common_vuejs_src_components_Modal__ = __webpack_require__(/*! package-common-vuejs/src/components/Modal */ 132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_package_common_vuejs_src_components_Notification__ = __webpack_require__(/*! package-common-vuejs/src/components/Notification */ 546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_package_common_vuejs_src_components_Breadcrumb__ = __webpack_require__(/*! package-common-vuejs/src/components/Breadcrumb */ 550);




var _templateObject = __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_taggedTemplateLiteral___default()(['query {\n          user: userInfo { id name isAdmin permissions }\n        }'], ['query {\n          user: userInfo { id name isAdmin permissions }\n        }']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation ($refreshToken: String!) {\n            tokenInfos: userRefreshToken(refreshToken: $refreshToken) {\n              access_token\n              expires_in\n            }\n          }'], ['mutation ($refreshToken: String!) {\n            tokenInfos: userRefreshToken(refreshToken: $refreshToken) {\n              access_token\n              expires_in\n            }\n          }']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation {\n              userLogout\n            }'], ['mutation {\n              userLogout\n            }']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_app_mixin__["a" /* AppMixin */]],
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_8_package_common_vuejs_src_components_Breadcrumb__["a" /* default */],
    Layout: __WEBPACK_IMPORTED_MODULE_5_package_common_vuejs_src_layouts_StandardLayout__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_6_package_common_vuejs_src_components_Modal__["default"],
    Notification: __WEBPACK_IMPORTED_MODULE_7_package_common_vuejs_src_components_Notification__["a" /* default */]
  },
  data: function data() {
    return {
      shouldRefresh: false
    };
  },

  props: {
    menu: Array
  },
  apollo: {
    user: {
      query: Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject),
      fetchPolicy: 'network-only',
      result: function result(_ref) {
        var user = _ref.data.user;

        this.$store.dispatch('setUser', user);
      },

      manual: true
    }
  },
  computed: {
    pageTitle: function pageTitle() {
      return this.$route.meta && this.$route.meta.title || this.$route.name;
    }
  },
  created: function created() {
    this.triggerRefresh();
  },

  methods: {
    /**
     * Trigger refresh right before expiration date
     */
    triggerRefresh: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        var DELAY_BEFORE_REFRESH, refreshToken, expiresAt, currentTime, delay;
        return __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                DELAY_BEFORE_REFRESH = 5000; // 5 sec before expiration

                refreshToken = localStorage.getItem('refresh_token');
                expiresAt = Number(localStorage.getItem('expires_at'));
                currentTime = new Date().getTime();
                delay = expiresAt - currentTime - DELAY_BEFORE_REFRESH;

                if (refreshToken && expiresAt && delay > 0) {
                  // Refresh auth_token
                  window.setTimeout(this.refresh.bind(this), expiresAt - currentTime - DELAY_BEFORE_REFRESH);
                } else {
                  this.shouldRefresh = true;
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function triggerRefresh() {
        return _ref2.apply(this, arguments);
      }

      return triggerRefresh;
    }(),

    /**
     * Use the refresh token to re-auth the user
     */
    refresh: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var refreshToken, _ref4, tokenInfos;

        return __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('Refreshing token...');
                refreshToken = localStorage.getItem('refresh_token');
                _context2.prev = 2;
                _context2.next = 5;
                return this.$apollo.mutate({
                  mutation: Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2),
                  variables: {
                    refreshToken: refreshToken
                  }
                });

              case 5:
                _ref4 = _context2.sent;
                tokenInfos = _ref4.data.tokenInfos;

                localStorage.setItem('expires_at', new Date().getTime() + tokenInfos.expires_in * 1000);
                _context2.next = 10;
                return this.$apollo.queries.user.refetch();

              case 10:
                this.triggerRefresh();
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](2);

                this.shouldRefresh = true;

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 13]]);
      }));

      function refresh() {
        return _ref3.apply(this, arguments);
      }

      return refresh;
    }(),
    logout: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.$apollo.mutate({
                  mutation: Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject3)
                });

              case 3:
                this.$store.dispatch('unsetUser');
                localStorage.clear();
                this.$router.push({ path: '/login', query: { referer: this.$route.fullPath } });
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](0);

                console.error(_context3.t0);

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 8]]);
      }));

      function logout() {
        return _ref5.apply(this, arguments);
      }

      return logout;
    }(),
    refreshBrowser: function refreshBrowser() {
      window.location.reload(true);
    }
  }
});

/***/ }),

/***/ 351:
/*!********************************************!*\
  !*** ./src/components/LayoutSignedOut.vue ***!
  \********************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_LayoutSignedOut_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./LayoutSignedOut.vue */ 352);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55a05312_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayoutSignedOut_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-55a05312","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./LayoutSignedOut.vue */ 556);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_LayoutSignedOut_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55a05312_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayoutSignedOut_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 352:
/*!***************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LayoutSignedOut.vue ***!
  \***************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/asyncToGenerator */ 75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/taggedTemplateLiteral */ 95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(/*! graphql-tag */ 59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_app_mixin__ = __webpack_require__(/*! ../mixins/app-mixin */ 78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_package_common_vuejs_src_layouts_LoginLayout__ = __webpack_require__(/*! package-common-vuejs/src/layouts/LoginLayout */ 553);




var _templateObject = __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_taggedTemplateLiteral___default()(['query {\n          user: userInfo { id name isAdmin permissions }\n        }'], ['query {\n          user: userInfo { id name isAdmin permissions }\n        }']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation ($refreshToken: String!) {\n                tokenInfos: userRefreshToken(refreshToken: $refreshToken) {\n                  access_token\n                  expires_in\n                }\n              }'], ['mutation ($refreshToken: String!) {\n                tokenInfos: userRefreshToken(refreshToken: $refreshToken) {\n                  access_token\n                  expires_in\n                }\n              }']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation ($username: String!, $password: String!) {\n              tokenInfos: userLogin(username: $username, password: $password) {\n                access_token\n                expires_in\n                refresh_token\n              }\n            }'], ['mutation ($username: String!, $password: String!) {\n              tokenInfos: userLogin(username: $username, password: $password) {\n                access_token\n                expires_in\n                refresh_token\n              }\n            }']);

//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_app_mixin__["a" /* AppMixin */]],
  components: {
    Layout: __WEBPACK_IMPORTED_MODULE_5_package_common_vuejs_src_layouts_LoginLayout__["a" /* default */]
  },
  data: function data() {
    return {
      error: null,
      loading: false,
      user: null
    };
  },

  apollo: {
    user: {
      query: Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject),
      fetchPolicy: 'network-only',
      result: function result(_ref) {
        var user = _ref.data.user;

        this.redirectAfterAuth(user);
      }
    }
  },
  created: function created() {
    this.refresh();
  },

  methods: {
    /**
     * Redirection déclenchée après une authentification réussie.
     * Ne dépend pas du hook `result()` de la smart query `user`, qui peut ne pas
     * se redéclencher après un `refetch()` faisant suite à l'échec initial systématique
     * de la query (non authentifié au montage de /login).
     */
    redirectAfterAuth: function redirectAfterAuth(user) {
      this.$store.dispatch('setUser', user);
      this.$router.push({ path: this.$route.query.referer || '/' });
    },

    /**
     * Use the refresh token to re-auth the user
     */
    refresh: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        var refreshToken, expiresAt, _ref3, tokenInfos, _ref4, user;

        return __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                refreshToken = localStorage.getItem('refresh_token');
                expiresAt = Number(localStorage.getItem('expires_at'));

                if (!(refreshToken && expiresAt && expiresAt < new Date().getTime())) {
                  _context.next = 14;
                  break;
                }

                _context.next = 6;
                return this.$apollo.mutate({
                  mutation: Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2),
                  variables: {
                    refreshToken: refreshToken
                  }
                });

              case 6:
                _ref3 = _context.sent;
                tokenInfos = _ref3.data.tokenInfos;

                localStorage.setItem('expires_at', new Date().getTime() + tokenInfos.expires_in * 1000);
                _context.next = 11;
                return this.$apollo.queries.user.refetch();

              case 11:
                _ref4 = _context.sent;
                user = _ref4.data.user;

                this.redirectAfterAuth(user);

              case 14:
                _context.next = 18;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](0);

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 16]]);
      }));

      function refresh() {
        return _ref2.apply(this, arguments);
      }

      return refresh;
    }(),
    login: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(_ref5) {
        var username = _ref5.username,
            password = _ref5.password;

        var _ref7, tokenInfos, _ref8, user;

        return __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (username) {
                  _context2.next = 3;
                  break;
                }

                this.error = 'Le nom d\'utilisateur est obligatoire !';
                return _context2.abrupt('return');

              case 3:
                if (password) {
                  _context2.next = 6;
                  break;
                }

                this.error = 'Le mot de passe est obligatoire !';
                return _context2.abrupt('return');

              case 6:
                this.loading = true;
                this.error = null;
                _context2.prev = 8;
                _context2.next = 11;
                return this.$apollo.mutate({
                  mutation: Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject3),
                  variables: {
                    username: username,
                    password: password
                  }
                });

              case 11:
                _ref7 = _context2.sent;
                tokenInfos = _ref7.data.tokenInfos;

                localStorage.setItem('refresh_token', tokenInfos.refresh_token);
                localStorage.setItem('expires_at', new Date().getTime() + tokenInfos.expires_in * 1000);
                _context2.next = 17;
                return this.$apollo.queries.user.refetch();

              case 17:
                _ref8 = _context2.sent;
                user = _ref8.data.user;

                this.redirectAfterAuth(user);
                this.loading = false;
                _context2.next = 34;
                break;

              case 23:
                _context2.prev = 23;
                _context2.t0 = _context2['catch'](8);

                this.loading = false;
                _context2.t1 = true;
                _context2.next = _context2.t1 === _context2.t0.message.includes('User not found!') ? 29 : _context2.t1 === _context2.t0.message.includes('Wrong password!') ? 31 : 33;
                break;

              case 29:
                this.error = 'L\'utilisateur n\'existe pas';
                return _context2.abrupt('break', 34);

              case 31:
                this.error = 'Le mot de passe est incorrect';
                return _context2.abrupt('break', 34);

              case 33:
                this.error = _context2.t0.message;

              case 34:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[8, 23]]);
      }));

      function login(_x) {
        return _ref6.apply(this, arguments);
      }

      return login;
    }()
  }
});

/***/ }),

/***/ 373:
/*!************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Group.vue ***!
  \************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 374:
/*!*************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/GroupWithKeepAlive.vue ***!
  \*************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 379:
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MediaImage.vue ***!
  \**********************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var extMatch = /^[^\.]*(\.[^\.]*)*\.(\w{1,6})$/;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Lightbox: function Lightbox() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, /*! package-common-vuejs/src/components/Lightbox */ 715));
    }
  },
  props: {
    media: Object,
    thumbnail: Boolean,
    preview: Boolean,
    group: String,
    emptyLabel: { type: String, default: 'Aucun fichier' }
  },
  methods: {
    getExtension: function getExtension(_ref) {
      var name = _ref.name,
          mime = _ref.mime;

      return name.match(extMatch) && name.replace(extMatch, '$2') || mime.replace(/^(.*\/)/, '');
    },
    isImage: function isImage(_ref2) {
      var mime = _ref2.mime;

      return mime && mime.match(/^image\//);
    }
  }
});

/***/ }),

/***/ 380:
/*!****************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishingStatus.vue ***!
  \****************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: Boolean
  }
});

/***/ }),

/***/ 381:
/*!****************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FormStickyHeader.vue ***!
  \****************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: String,
    links: Object
  }
});

/***/ }),

/***/ 382:
/*!**************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FormFileUpload.vue ***!
  \**************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_slicedToArray__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/slicedToArray */ 130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/asyncToGenerator */ 75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/toConsumableArray */ 131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__usr_src_apps_admin_node_modules_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/taggedTemplateLiteral */ 95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__usr_src_apps_admin_node_modules_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__usr_src_apps_admin_node_modules_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag__ = __webpack_require__(/*! graphql-tag */ 59);






var _templateObject = __WEBPACK_IMPORTED_MODULE_4__usr_src_apps_admin_node_modules_babel_runtime_helpers_taggedTemplateLiteral___default()(['query($id: ID!) {\n    media: mediaFetchById(id: $id) {\n      ', '\n    }\n  }'], ['query($id: ID!) {\n    media: mediaFetchById(id: $id) {\n      ', '\n    }\n  }']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_4__usr_src_apps_admin_node_modules_babel_runtime_helpers_taggedTemplateLiteral___default()(['query MediasById($ids: [ID]) {\n    medias: mediasFetchByIds(ids: $ids) {\n      ', '\n    }\n  }'], ['query MediasById($ids: [ID]) {\n    medias: mediasFetchByIds(ids: $ids) {\n      ', '\n    }\n  }']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_4__usr_src_apps_admin_node_modules_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation ($files: [Upload]) {\n    results: mediaUpload(files: $files) {\n      ', '\n    }\n  }'], ['mutation ($files: [Upload]) {\n    results: mediaUpload(files: $files) {\n      ', '\n    }\n  }']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_4__usr_src_apps_admin_node_modules_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation ($id: ID!, $file: Upload) {\n    result: mediaReplace(id: $id, file: $file) {\n      ', '\n    }\n  }'], ['mutation ($id: ID!, $file: Upload) {\n    result: mediaReplace(id: $id, file: $file) {\n      ', '\n    }\n  }']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_4__usr_src_apps_admin_node_modules_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation ($id: ID!) {\n    result: mediaRemove(id: $id)\n  }'], ['mutation ($id: ID!) {\n    result: mediaRemove(id: $id)\n  }']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var returnFields = 'id name mime length';

var MediaFetchByIdQuery = Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject, returnFields);
var MediaFetchByIdsQuery = Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject2, returnFields);
var MediaUploadMutation = Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject3, returnFields);
var MediaReplaceMutation = Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject4, returnFields);
var MediaRemoveMutation = Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject5);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Modal: function Modal() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, /*! package-common-vuejs/src/components/Modal */ 132));
    },
    FormUpload: function FormUpload() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, /*! package-common-vuejs/src/components/form/FormUpload */ 717));
    },
    FormTypeahead: function FormTypeahead() {
      return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, /*! package-common-vuejs/src/components/form/FormTypeahead */ 712));
    }
  },
  props: {
    value: [Array, String],
    limit: { type: Number, default: 10 },
    multiple: Boolean,
    image: Boolean,
    editable: Boolean
  },
  data: function data() {
    return {
      media: null,
      medias: [],
      loading: 0,
      error: null,
      openEditMedia: null,
      openDeleteMedia: null
    };
  },

  computed: {
    mediasIds: function mediasIds() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_3__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray___default()(this.value || []));
    },
    dataset: function dataset() {
      var _this = this;

      return {
        source: function source(query, syncResults, asyncResults) {
          return _this.searchMedia(query).then(asyncResults);
        },
        limit: 50,
        display: function display(_ref) {
          var name = _ref.name,
              mime = _ref.mime,
              length = _ref.length;
          return '' + name;
        },
        templates: {
          notFound: '<p class="no-margin text-muted pl-10 pr-10 pt-5 pb-5">Aucun r\xE9sultat</p>',
          suggestion: function suggestion(media) {
            var name = media.name,
                mime = media.mime,
                length = media.length;

            return '<div>\n                ' + (_this.image ? '<figure class="pull-left position-left"><img src="' + _this.$options.filters.media(media, 'manager-thumbnail') + '" width="54" height="40" alt="' + (media.alt || media.name) + '" class="img-thumbnail img-rounded" /></figure>' : '') + '\n                <p class="no-margin"><strong>' + name + '</strong></p>\n                <p class="no-margin text-muted"><small><em>' + mime + ' - ' + _this.$options.filters.filesize(length) + '</em></small></p>\n              </div>';
          }
        }
      };
    }
  },
  apollo: {
    media: {
      query: MediaFetchByIdQuery,
      fetchPolicy: 'cache-and-network',
      skip: function skip() {
        return this.multiple || !this.value;
      },
      variables: function variables() {
        return { id: this.value };
      }
    },
    medias: {
      query: MediaFetchByIdsQuery,
      fetchPolicy: 'cache-and-network',
      skip: function skip() {
        return !this.multiple || !this.mediasIds;
      },
      variables: function variables() {
        return { ids: this.mediasIds };
      }
    }
  },
  methods: {
    clear: function clear() {
      var valueToEmit = this.multiple ? [] : null;
      this.media = null;
      this.medias = [];
      this.$emit('input', valueToEmit);
      this.$emit('change', valueToEmit);
    },
    processUpload: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(files) {
        var _ref3, data, valueToEmit, _medias;

        return __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (files.length) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                this.loading++;
                this.error = null;
                _context.prev = 4;
                _context.next = 7;
                return this.$apollo.mutate({
                  mutation: MediaUploadMutation,
                  variables: {
                    files: files
                  }
                });

              case 7:
                _ref3 = _context.sent;
                data = _ref3.data;
                valueToEmit = void 0;

                if (this.multiple) {
                  (_medias = this.medias).concat.apply(_medias, __WEBPACK_IMPORTED_MODULE_3__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray___default()(data.results)); // shortcut
                  valueToEmit = [].concat(__WEBPACK_IMPORTED_MODULE_3__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray___default()(this.value || []), __WEBPACK_IMPORTED_MODULE_3__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray___default()(data.results.map(function (_ref4) {
                    var id = _ref4.id;
                    return id;
                  })));
                } else {
                  this.media = data.results[0]; // shortcut
                  valueToEmit = data.results[0].id;
                }
                this.$emit('input', valueToEmit);
                this.$emit('change', valueToEmit);
                this.loading--;
                _context.next = 21;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](4);

                console.error(_context.t0);
                this.error = _context.t0.message;
                this.loading--;

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 16]]);
      }));

      function processUpload(_x) {
        return _ref2.apply(this, arguments);
      }

      return processUpload;
    }(),
    processUploadMedia: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(_ref5) {
        var _this2 = this;

        var _ref7 = __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_slicedToArray___default()(_ref5, 1),
            file = _ref7[0];

        var _ref8, data;

        return __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!file || !this.openEditMedia)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                this.loading++;
                this.error = null;
                _context2.prev = 4;
                _context2.next = 7;
                return this.$apollo.mutate({
                  mutation: MediaReplaceMutation,
                  variables: {
                    id: this.openEditMedia.id,
                    file: file
                  }
                });

              case 7:
                _ref8 = _context2.sent;
                data = _ref8.data;

                if (this.multiple) {
                  this.medias = this.medias.map(function (media) {
                    return media.id !== _this2.openEditMedia.id ? media : data.result;
                  });
                } else {
                  this.media = data.result; // shortcut
                }
                this.openEditMedia = null;
                this.loading--;
                _context2.next = 19;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](4);

                console.error(_context2.t0);
                this.error = _context2.t0.message;
                this.loading--;

              case 19:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 14]]);
      }));

      function processUploadMedia(_x2) {
        return _ref6.apply(this, arguments);
      }

      return processUploadMedia;
    }(),
    processDeleteMedia: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _this3 = this;

        var _ref10, data, valueToEmit;

        return __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.openDeleteMedia) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:
                this.loading++;
                _context3.prev = 3;
                _context3.next = 6;
                return this.$apollo.mutate({
                  mutation: MediaRemoveMutation,
                  variables: {
                    id: this.openDeleteMedia.id
                  }
                });

              case 6:
                _ref10 = _context3.sent;
                data = _ref10.data;
                valueToEmit = void 0;

                if (this.multiple) {
                  this.medias = this.medias.filter(function (media) {
                    return media.id !== _this3.openDeleteMedia.id ? media : data.result;
                  });
                  valueToEmit = (this.value || []).filter(function (id) {
                    return id !== _this3.openDeleteMedia.id;
                  });
                } else {
                  this.media = null;
                  valueToEmit = data.results[0].id;
                }
                this.$emit('input', valueToEmit);
                this.$emit('change', valueToEmit);
                this.openDeleteMedia = null;
                this.loading--;
                _context3.next = 21;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3['catch'](3);

                console.error(_context3.t0);
                this.error = _context3.t0.message;
                this.loading--;

              case 21:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 16]]);
      }));

      function processDeleteMedia() {
        return _ref9.apply(this, arguments);
      }

      return processDeleteMedia;
    }()
  }
});

/***/ }),

/***/ 383:
/*!*********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FormOrder.vue ***!
  \*********************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: [Number, String],
    disabled: Boolean,
    required: Boolean
  },
  computed: {
    model: {
      get: function get() {
        return 100 - (parseInt(this.value, 10) || 0);
      },
      set: function set(value) {
        var order = 100 - (value || 0);
        this.$emit("input", order);
        this.$emit("change", order);
      }
    }
  }
});

/***/ }),

/***/ 384:
/*!********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Activity.vue ***!
  \********************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: Object
  }
});

/***/ }),

/***/ 385:
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ColorBadge.vue ***!
  \**********************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: Object,
    size: { type: String, default: 'normal' }
  },
  computed: {
    width: function width() {
      switch (this.size) {
        case 'mini':
          return '20px';
        case 'small':
          return '24px';
        case 'normal':default:
          return '36px';
      }
    }
  }
});

/***/ }),

/***/ 386:
/*!***************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FormSelectColor.vue ***!
  \***************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_filter__ = __webpack_require__(/*! lodash/filter */ 420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_groupBy__ = __webpack_require__(/*! lodash/groupBy */ 700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_groupBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_groupBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ColorBadge__ = __webpack_require__(/*! ./ColorBadge */ 135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OptionHtml__ = __webpack_require__(/*! ./OptionHtml */ 142);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FormMultiselect: function FormMultiselect() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, /*! package-common-vuejs/src/components/form/FormMultiselect */ 711));
    },
    ColorBadge: __WEBPACK_IMPORTED_MODULE_2__ColorBadge__["default"],
    OptionHtml: __WEBPACK_IMPORTED_MODULE_3__OptionHtml__["default"]
  },
  props: {
    value: [String, Array],
    placeholder: String,
    required: Boolean,
    colors: Array,
    buttonClass: String
  },
  computed: {
    colorsByGroup: function colorsByGroup() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_groupBy___default()(this.colors, "group.name");
    },
    parameters: function parameters() {
      return {
        enableClickableOptGroups: true,
        delimiterText: ' ',
        numberDisplayed: 10
      };
    },

    model: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        if (Array.isArray(value)) {
          value = __WEBPACK_IMPORTED_MODULE_0_lodash_filter___default()(value);
        }
        this.$emit("input", value);
        this.$emit("change", value);
      }
    }
  }
});

/***/ }),

/***/ 387:
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/OptionHtml.vue ***!
  \**********************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {}
  },
  mounted: function mounted() {
    this.$refs.option.innerText = this.$refs.option.innerHTML;
  }
});

/***/ }),

/***/ 396:
/*!*********************************************!*\
  !*** ./src/components/FormStickyHeader.vue ***!
  \*********************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_FormStickyHeader_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./FormStickyHeader.vue */ 381);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70e17011_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormStickyHeader_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-70e17011","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./FormStickyHeader.vue */ 687);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-70e17011","scoped":false,"hasInlineConfig":true}!less-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./FormStickyHeader.vue */ 686)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_FormStickyHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70e17011_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormStickyHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 403:
/*!*******************************************!*\
  !*** ./src/components/FormFileUpload.vue ***!
  \*******************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_FormFileUpload_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./FormFileUpload.vue */ 382);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58fafe92_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormFileUpload_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-58fafe92","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./FormFileUpload.vue */ 693);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-58fafe92","scoped":false,"hasInlineConfig":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./FormFileUpload.vue */ 688)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_FormFileUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58fafe92_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormFileUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 405:
/*!**************************************!*\
  !*** ./src/components/FormOrder.vue ***!
  \**************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_FormOrder_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./FormOrder.vue */ 383);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a3f0ab9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormOrder_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3a3f0ab9","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./FormOrder.vue */ 694);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_FormOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a3f0ab9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 409:
/*!***************************************!*\
  !*** ./src/components/MediaImage.vue ***!
  \***************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MediaImage_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./MediaImage.vue */ 379);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59b0cc1e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MediaImage_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-59b0cc1e","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./MediaImage.vue */ 684);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-59b0cc1e","scoped":true,"hasInlineConfig":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MediaImage.vue */ 683)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59b0cc1e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MediaImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59b0cc1e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MediaImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 411:
/*!*********************************************!*\
  !*** ./src/components/PublishingStatus.vue ***!
  \*********************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_PublishingStatus_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./PublishingStatus.vue */ 380);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11ad1a27_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublishingStatus_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-11ad1a27","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./PublishingStatus.vue */ 685);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_PublishingStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11ad1a27_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublishingStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 414:
/*!********************************************!*\
  !*** ./src/components/FormSelectColor.vue ***!
  \********************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_FormSelectColor_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./FormSelectColor.vue */ 386);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c64ae0a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSelectColor_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-c64ae0a8","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./FormSelectColor.vue */ 704);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-c64ae0a8","scoped":false,"hasInlineConfig":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./FormSelectColor.vue */ 699)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_FormSelectColor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c64ae0a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSelectColor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 416:
/*!*************************************!*\
  !*** ./src/components/Activity.vue ***!
  \*************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Activity_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Activity.vue */ 384);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42709f1f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Activity_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-42709f1f","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Activity.vue */ 695);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Activity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42709f1f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Activity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 421:
/*!***********************************************!*\
  !*** multi ./src/polyfills.js ./src/index.js ***!
  \***********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! /usr/src/apps/admin/src/polyfills.js */422);
module.exports = __webpack_require__(/*! /usr/src/apps/admin/src/index.js */426);


/***/ }),

/***/ 422:
/*!**************************!*\
  !*** ./src/polyfills.js ***!
  \**************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

if (!window.Promise) {
  window.Promise = __webpack_require__(/*! promise-polyfill */ 423);
}

Object.assign = __webpack_require__(/*! object-assign */ 425);

/***/ }),

/***/ 426:
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_App_vue__ = __webpack_require__(/*! ./components/App.vue */ 143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_package_common_vuejs_src_components_Column__ = __webpack_require__(/*! package-common-vuejs/src/components/Column */ 444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_package_common_vuejs_src_layouts_Error404Layout__ = __webpack_require__(/*! package-common-vuejs/src/layouts/Error404Layout */ 446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_package_common_vuejs_src_components_form_FormActions__ = __webpack_require__(/*! package-common-vuejs/src/components/form/FormActions */ 449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_package_common_vuejs_src_components_form_FormButton__ = __webpack_require__(/*! package-common-vuejs/src/components/form/FormButton */ 451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_package_common_vuejs_src_components_form_FormCheckbox__ = __webpack_require__(/*! package-common-vuejs/src/components/form/FormCheckbox */ 453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_package_common_vuejs_src_components_form_FormDate__ = __webpack_require__(/*! package-common-vuejs/src/components/form/FormDate */ 455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_package_common_vuejs_src_components_form_FormFieldset__ = __webpack_require__(/*! package-common-vuejs/src/components/form/FormFieldset */ 462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_package_common_vuejs_src_components_form_FormGroup__ = __webpack_require__(/*! package-common-vuejs/src/components/form/FormGroup */ 465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_package_common_vuejs_src_components_form_FormInput__ = __webpack_require__(/*! package-common-vuejs/src/components/form/FormInput */ 467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_package_common_vuejs_src_components_form_FormRadio__ = __webpack_require__(/*! package-common-vuejs/src/components/form/FormRadio */ 469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_package_common_vuejs_src_components_form_FormSelect__ = __webpack_require__(/*! package-common-vuejs/src/components/form/FormSelect */ 471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_package_common_vuejs_src_components_form_FormTextarea__ = __webpack_require__(/*! package-common-vuejs/src/components/form/FormTextarea */ 474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_LayoutSignedIn_vue__ = __webpack_require__(/*! ./components/LayoutSignedIn.vue */ 296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_LayoutSignedOut_vue__ = __webpack_require__(/*! ./components/LayoutSignedOut.vue */ 351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_package_common_vuejs_src_components_Panel__ = __webpack_require__(/*! package-common-vuejs/src/components/Panel */ 557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_package_common_vuejs_src_components_Row__ = __webpack_require__(/*! package-common-vuejs/src/components/Row */ 559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue__ = __webpack_require__(/*! vue */ 356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_apollo__ = __webpack_require__(/*! vue-apollo */ 561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_resource__ = __webpack_require__(/*! vue-resource */ 562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_router__ = __webpack_require__(/*! vue-router */ 564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__apollo__ = __webpack_require__(/*! ./apollo */ 565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_forIn__ = __webpack_require__(/*! lodash/forIn */ 602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_forIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash_forIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__filters__ = __webpack_require__(/*! ./filters */ 613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__menu__ = __webpack_require__(/*! ./menu */ 620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__store__ = __webpack_require__(/*! ./store */ 705);
















// Most frequently used components











//import 'package-common-vuejs/dist/package-common-vuejs.css';


__WEBPACK_IMPORTED_MODULE_17_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_18_vue_apollo__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_17_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_20_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_17_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_19_vue_resource__["a" /* default */]);

var requireComponents = __webpack_require__(/*! ./components */ 710);
requireComponents.keys().forEach(function (key) {
  var component = requireComponents(key);
  var name = key.substring(key.lastIndexOf("/") + 1);
  name = name.substring(0, name.lastIndexOf(".vue"));
  name = name.substring(0, 1).toLowerCase() + name.substring(1);
  __WEBPACK_IMPORTED_MODULE_17_vue__["a" /* default */].component(name, component);
});

__WEBPACK_IMPORTED_MODULE_17_vue__["a" /* default */].component("Row", __WEBPACK_IMPORTED_MODULE_16_package_common_vuejs_src_components_Row__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_17_vue__["a" /* default */].component("Column", __WEBPACK_IMPORTED_MODULE_1_package_common_vuejs_src_components_Column__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_17_vue__["a" /* default */].component("Panel", __WEBPACK_IMPORTED_MODULE_15_package_common_vuejs_src_components_Panel__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_17_vue__["a" /* default */].component("FormActions", __WEBPACK_IMPORTED_MODULE_3_package_common_vuejs_src_components_form_FormActions__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_17_vue__["a" /* default */].component("FormButton", __WEBPACK_IMPORTED_MODULE_4_package_common_vuejs_src_components_form_FormButton__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_17_vue__["a" /* default */].component("FormCheckbox", __WEBPACK_IMPORTED_MODULE_5_package_common_vuejs_src_components_form_FormCheckbox__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_17_vue__["a" /* default */].component("FormDate", __WEBPACK_IMPORTED_MODULE_6_package_common_vuejs_src_components_form_FormDate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_17_vue__["a" /* default */].component("FormFieldset", __WEBPACK_IMPORTED_MODULE_7_package_common_vuejs_src_components_form_FormFieldset__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_17_vue__["a" /* default */].component("FormGroup", __WEBPACK_IMPORTED_MODULE_8_package_common_vuejs_src_components_form_FormGroup__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_17_vue__["a" /* default */].component("FormInput", __WEBPACK_IMPORTED_MODULE_9_package_common_vuejs_src_components_form_FormInput__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_17_vue__["a" /* default */].component("FormSelect", __WEBPACK_IMPORTED_MODULE_11_package_common_vuejs_src_components_form_FormSelect__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_17_vue__["a" /* default */].component("FormRadio", __WEBPACK_IMPORTED_MODULE_10_package_common_vuejs_src_components_form_FormRadio__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_17_vue__["a" /* default */].component("FormTextarea", __WEBPACK_IMPORTED_MODULE_12_package_common_vuejs_src_components_form_FormTextarea__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_22_lodash_forIn___default()(__WEBPACK_IMPORTED_MODULE_23__filters__["a" /* default */], function (value, prop) {
  __WEBPACK_IMPORTED_MODULE_17_vue__["a" /* default */].filter(prop, value);
});

__WEBPACK_IMPORTED_MODULE_17_vue__["a" /* default */].mixin({
  computed: {
    pageTitle: function pageTitle() {
      return this.$route.meta && this.$route.meta.title || this.$route.name;
    }
  }
});

var routes = [{ path: "/login", component: __WEBPACK_IMPORTED_MODULE_14__components_LayoutSignedOut_vue__["default"], meta: { title: "Connexion" } }, {
  path: "/",
  component: __WEBPACK_IMPORTED_MODULE_13__components_LayoutSignedIn_vue__["default"],
  props: { menu: __WEBPACK_IMPORTED_MODULE_24__menu__["a" /* default */] },
  meta: { breadcrumb: "Accueil", title: "Accueil" },
  beforeEnter: function beforeEnter(to, from, next) {
    if (!__WEBPACK_IMPORTED_MODULE_25__store__["a" /* default */].state.user) {
      return next({ path: "/login", query: { referer: to.fullPath } });
    }
    return next();
  },

  children: __WEBPACK_IMPORTED_MODULE_24__menu__["a" /* default */]
}, {
  path: "*",
  meta: { title: "Page non trouvée" },
  component: __WEBPACK_IMPORTED_MODULE_2_package_common_vuejs_src_layouts_Error404Layout__["a" /* default */]
}];

var router = new __WEBPACK_IMPORTED_MODULE_20_vue_router__["a" /* default */]({
  mode: "history",
  routes: routes
});

router.beforeEach(function (to, from, next) {
  document.title = (to.meta.title || to.meta.name || to.name) + " - Administration Netexial";
  next();
});

new __WEBPACK_IMPORTED_MODULE_17_vue__["a" /* default */]({
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_25__store__["a" /* default */],
  apolloProvider: new __WEBPACK_IMPORTED_MODULE_18_vue_apollo__["a" /* default */]({
    defaultClient: __WEBPACK_IMPORTED_MODULE_21__apollo__["a" /* client */]
  }),
  el: "body",
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_0__components_App_vue__["default"]);
  }
});

/***/ }),

/***/ 427:
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2eb13c0c","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/App.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 443:
/*!*********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2eb13c0c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue ***!
  \*********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("app-layout",{tag:"body",attrs:{"authenticated":!!_vm.$store.state.user}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 552:
/*!********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d533bf0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LayoutSignedIn.vue ***!
  \********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"user":_vm.$store.state.user,"menu":_vm.menu},on:{"logout":_vm.logout}},[_c('h4',{attrs:{"slot":"page-title"},slot:"page-title"},[_vm._v(_vm._s(_vm.pageTitle))]),_vm._v(" "),_c('breadcrumb',{attrs:{"slot":"breadcrumb","routes":_vm.$route.matched},slot:"breadcrumb"}),_vm._v(" "),(_vm.shouldRefresh)?_c('modal',[_c('h4',[_vm._v("Votre session est expirée !")]),_vm._v(" "),_c('p',[_vm._v("Réactualisez la page et reconnectez-vous pour continuer...")]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning",on:{"click":_vm.refreshBrowser}},[_vm._v("Actualiser la page")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.$store.state.notifications),function(notification){return _c('notification',{key:notification.id,attrs:{"type":notification.type,"title":notification.title,"icon":notification.icon},domProps:{"innerHTML":_vm._s(notification.text)},on:{"close":function($event){return _vm.removeNotification(notification)}}})}),_vm._v(" "),_c('router-view')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 556:
/*!*********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55a05312","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LayoutSignedOut.vue ***!
  \*********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"title":"Administration - Netexial","loading":_vm.loading,"error":_vm.error},on:{"tryLogin":_vm.login}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 563:
/*!*********************!*\
  !*** got (ignored) ***!
  \*********************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 565:
/*!***********************!*\
  !*** ./src/apollo.js ***!
  \***********************/
/*! exports provided: client */
/*! exports used: client */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return client; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_cache_inmemory__ = __webpack_require__(/*! apollo-cache-inmemory */ 566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_client__ = __webpack_require__(/*! apollo-client */ 571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_upload_client__ = __webpack_require__(/*! apollo-upload-client */ 577);




var client = new __WEBPACK_IMPORTED_MODULE_1_apollo_client__["a" /* ApolloClient */]({
  link: Object(__WEBPACK_IMPORTED_MODULE_2_apollo_upload_client__["a" /* createUploadLink */])({
    uri: "https://api.catalogueinteractifinitial.fr/v1/",
    credentials: "include"
  }),
  cache: new __WEBPACK_IMPORTED_MODULE_0_apollo_cache_inmemory__["a" /* InMemoryCache */](),
  connectToDevTools: true
});

/***/ }),

/***/ 613:
/*!************************!*\
  !*** ./src/filters.js ***!
  \************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_slicedToArray__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/slicedToArray */ 130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(/*! moment */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);


__WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale('fr');

var cdnUri = "https://cdn.catalogueinteractifinitial.fr/";

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * Formatte un email
   * @param text
   */
  email: function email(text) {
    return ('' + text).toLowerCase();
  },

  /**
   * Formatte un numéro de téléphone
   * @param text
   */
  phone: function phone(text) {
    var cleanPhone = ('' + text).replace(/[^0-9]+/gim, '');
    if (cleanPhone.match(/^\+\d{11}$/) || cleanPhone.match(/^\d{10}$/)) {
      return cleanPhone.replace(/^(\+\d{3}|\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/, '$1 $2 $3 $4 $5');
    }
    return text;
  },

  /**
   * Formate une date
   * @param text
   * @param format
   */
  date: function date(text) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD/MM/YYYY';
    return text ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(text).format(format) : '-';
  },
  datetime: function datetime(text) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD/MM/YYYY à HH:mm';
    return text ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(text).format(format) : '-';
  },
  ago: function ago(text) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(text).from();
  },

  number: function number(text) {
    return Number(text || 0).toFixed(0).replace(/(\d)(\d{3})$/, '$1 $2').replace(/(\d)(\d{3})(\s\d{3})$/, '$1 $2$3');
  },

  percentage: function percentage(_percentage) {
    var addPlus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return '' + (_percentage < 0 || !addPlus ? '' : '+') + Number((_percentage || 0) * 100).toFixed(1) + '%';
  },

  filesize: function filesize() {
    var sizeInBytes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    var sizes = [[1073741824, 'Go'], [1048576, 'Mo'], [1024, 'ko'], [1, 'octets']];
    var ret = '';
    sizes.forEach(function (_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          size = _ref2[0],
          unit = _ref2[1];

      if (!ret && sizeInBytes > size / 2) {
        ret = Number(sizeInBytes / size).toFixed(2).replace('.', '.') + '\xA0' + unit;
      }
      return !ret;
    });
    return ret || '-';
  },

  capitalize: function capitalize() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    text = text.trim().toLowerCase();
    var result = '';
    for (var i = 0; i < text.length; i++) {
      if (i === 0 || /^(\s|-)$/.test(text.charAt(i - 1))) {
        result += text.charAt(i).toUpperCase();
      } else {
        result += text.charAt(i);
      }
    }
    return result;
  },

  nl2br: function nl2br() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return text.replace(/\r?\n/, '<br />');
  },

  uppercase: function uppercase(text) {
    return text.toUpperCase();
  },

  join: function join() {
    var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ', ';
    return values.join(sep);
  },

  media: function media(_media) {
    var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'original';
    return cdnUri + 'media/' + _media.id + '/' + mode + '/' + (_media.hash || '0') + '-' + _media.name;
  },
  cdn: function cdn() {
    for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    return '' + cdnUri + params.join('/');
  }
});

/***/ }),

/***/ 620:
/*!*********************!*\
  !*** ./src/menu.js ***!
  \*********************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Group_vue__ = __webpack_require__(/*! ./pages/Group.vue */ 621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_GroupWithKeepAlive_vue__ = __webpack_require__(/*! ./pages/GroupWithKeepAlive.vue */ 623);



/* harmony default export */ __webpack_exports__["a"] = ([{
  path: "",
  name: "home",
  component: function component() {
    return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, /*! ./pages/Home.vue */ 713));
  },
  meta: { exact: true, title: "Tableau de bord" }
}, {
  path: "categories",
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Group_vue__["a" /* default */],
  meta: { menu: "Métiers", children: false },
  children: [{
    path: "",
    name: "categories",
    component: function component() {
      return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, /*! ./pages/categories/CategoriesList.vue */ 714));
    },
    meta: { exact: true, menu: "Liste", title: "Liste des métiers" }
  }, {
    path: "create",
    name: "category/create",
    component: function component() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, /*! ./pages/categories/CategoryCreate.vue */ 716));
    },
    meta: { menu: "Ajout", title: "Ajout d'un m\xE9tier" }
  }, {
    path: ":id/edit",
    name: "category/edit",
    component: function component() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, /*! ./pages/categories/CategoryEdit.vue */ 718));
    },
    meta: { menu: "Édition", title: "\xC9dition d'un m\xE9tier" }
  }]
}, {
  path: "collections",
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Group_vue__["a" /* default */],
  meta: { menu: "Collections", children: false },
  children: [{
    path: "",
    name: "collections",
    component: function component() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, /*! ./pages/collections/CollectionsList.vue */ 719));
    },
    meta: { exact: true, menu: "Liste", title: "Liste des collections" }
  }, {
    path: "create",
    name: "collection/create",
    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, /*! ./pages/collections/CollectionCreate.vue */ 720));
    },
    meta: { menu: "Ajout", title: "Ajout d'une collection" }
  }, {
    path: ":id/edit",
    name: "collection/edit",
    component: function component() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, /*! ./pages/collections/CollectionEdit.vue */ 721));
    },
    meta: { menu: "Édition", title: "\xC9dition d'une collection" }
  }]
}, {
  path: "colors",
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Group_vue__["a" /* default */],
  meta: { menu: "Couleurs", children: false },
  children: [{
    path: "",
    name: "colors",
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, /*! ./pages/colors/Colors.vue */ 722));
    },
    meta: { exact: true, menu: "Liste", title: "Gestion des couleurs" }
  }]
}, {
  path: "products",
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Group_vue__["a" /* default */],
  meta: { menu: "Produits", children: false },
  children: [{
    path: "",
    name: "products",
    component: function component() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, /*! ./pages/products/ProductsList.vue */ 723));
    },
    meta: { exact: true, menu: "Liste", title: "Gestion des produits" }
  }, {
    path: "create",
    name: "product/create",
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, /*! ./pages/products/ProductCreate.vue */ 724));
    },
    meta: { menu: "Ajout", title: "Ajout d'un produit" }
  }, {
    path: ":id/edit",
    name: "product/edit",
    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, /*! ./pages/products/ProductEdit.vue */ 725));
    },
    meta: { menu: "Édition", title: "\xC9dition d'un produit" }
  }, {
    path: ":id/variants",
    name: "product/variants",
    component: function component() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, /*! ./pages/products/ProductVariants.vue */ 726));
    },
    meta: { menu: "Déclinaisons", title: "D\xE9clinaisons d'un produit" }
  }]
}]);

/***/ }),

/***/ 621:
/*!*****************************!*\
  !*** ./src/pages/Group.vue ***!
  \*****************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Group_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Group.vue */ 373);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_695bd97d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Group_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-695bd97d","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Group.vue */ 622);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_695bd97d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 622:
/*!******************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-695bd97d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Group.vue ***!
  \******************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 623:
/*!******************************************!*\
  !*** ./src/pages/GroupWithKeepAlive.vue ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_GroupWithKeepAlive_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./GroupWithKeepAlive.vue */ 374);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f66032c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupWithKeepAlive_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6f66032c","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./GroupWithKeepAlive.vue */ 624);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_GroupWithKeepAlive_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f66032c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupWithKeepAlive_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 624:
/*!*******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f66032c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/GroupWithKeepAlive.vue ***!
  \*******************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('keep-alive',[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 683:
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-59b0cc1e","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MediaImage.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 684:
/*!***************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59b0cc1e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MediaImage.vue ***!
  \***************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.media)?_c('lightbox',{attrs:{"href":_vm._f("media")(_vm.media,'original'),"title":_vm.media && (_vm.media.description || _vm.media.name),"group":_vm.group}},[(_vm.thumbnail)?[_c('div',{staticClass:"image-thumbnail img-rounded empty-thumbnail",class:{'no-image': !_vm.isImage(_vm.media)}},[_c('div',[_c('i',{staticClass:"icon-file-empty position-left"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getExtension(_vm.media)))])])]),_vm._v(" "),(_vm.isImage(_vm.media))?_c('img',{staticClass:"img-thumbnail img-rounded",attrs:{"src":_vm._f("media")(_vm.media,'admin-thumbnail'),"width":"95","height":"70","alt":_vm.media.alt || _vm.media.name}}):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.preview)?[(_vm.isImage(_vm.media))?_c('img',{staticClass:"img-thumbnail img-rounded",attrs:{"src":_vm._f("media")(_vm.media,'admin-preview'),"width":"640","alt":_vm.media.alt || _vm.media.name}}):_c('span',[_c('i',{staticClass:"icon-file-empty position-left"}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.media.name))])])]:_vm._e()],2):_c('span',{staticClass:"text-muted",domProps:{"textContent":_vm._s(_vm.emptyLabel)}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 685:
/*!**********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11ad1a27","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishingStatus.vue ***!
  \**********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.value),expression:"value"}],staticClass:"label label-success",on:{"click":function($event){return _vm.$emit('hide')}}},[_vm._v("Visible")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.value),expression:"!value"}],staticClass:"label label-default label-flat text-grey-300",on:{"click":function($event){return _vm.$emit('show')}}},[_vm._v("Masqué")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 686:
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-70e17011","scoped":false,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/FormStickyHeader.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 687:
/*!**********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70e17011","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormStickyHeader.vue ***!
  \**********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-actions',{staticClass:"header sticky-header"},[_c('h1',{attrs:{"slot":"left"},slot:"left"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.links)?_c('nav',{attrs:{"slot":"left"},slot:"left"},[_c('i',{staticClass:"icon-square-right text-muted text-size-mini"}),_vm._v(" \n    "),_vm._l((_vm.links),function(label,link,index){return [(index)?[_vm._v(" | ")]:_vm._e(),_c('a',{attrs:{"href":("#" + link)},domProps:{"textContent":_vm._s(label)}})]})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix mt-20 mb-20"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 688:
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58fafe92","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/FormFileUpload.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 693:
/*!********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58fafe92","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormFileUpload.vue ***!
  \********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-media"},[(_vm.multiple? (_vm.medias && _vm.medias.length): _vm.media)?_c('div',{staticClass:"preview mb-5"},[_vm._t("default",function(){return [_c('div',{staticClass:"well border-left border-left-primary"},[_c('a',{staticClass:"delete",attrs:{"href":"#","title":_vm.multiple? 'Tout enlever': 'Enlever ce fichier'},on:{"click":function($event){$event.preventDefault();return _vm.clear.apply(null, arguments)}}},[_c('i',{staticClass:"icon-cross pull-right"})]),_vm._v(" "),(_vm.multiple)?_c('div',[(_vm.image)?_c('div',_vm._l((_vm.medias),function(media){return _c('div',{key:media.id,staticClass:"img-thumbnail img-rounded mr-5 mb-5"},[_c('div',{staticClass:"thumb"},[_c('img',{attrs:{"src":_vm._f("media")(media,'admin-thumbnail'),"width":"95","height":"70","alt":media.alt || media.name}}),_vm._v(" "),_c('p',{staticClass:"no-margin text-overflow text-center"},[_c('strong',[_vm._v(_vm._s(media.name))]),_c('br'),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm._f("filesize")(media.length)))])]),_vm._v(" "),(_vm.editable)?_c('div',{staticClass:"caption-overflow"},[_c('span',[_c('button',{staticClass:"btn border-white text-white btn-flat btn-icon btn-rounded",attrs:{"type":"button"},on:{"click":function($event){_vm.openEditMedia = media}}},[_c('i',{staticClass:"icon-pencil"})]),_vm._v(" "),_c('button',{staticClass:"btn border-white text-white btn-flat btn-icon btn-rounded",attrs:{"type":"button"},on:{"click":function($event){_vm.openDeleteMedia = media}}},[_c('i',{staticClass:"icon-trash"})])])]):_vm._e()])])}),0):_c('div',[_vm._v("\n            Fichier(s) sélectionné(s) :\n            "),_c('ul',_vm._l((_vm.medias),function(media){return _c('li',[_c('strong',[_vm._v(_vm._s(media.name))]),_vm._v(" "),(_vm.editable)?_c('span',[_c('button',{staticClass:"btn btn-icon",attrs:{"type":"button"},on:{"click":function($event){_vm.openEditMedia = media}}},[_c('i',{staticClass:"icon-pencil"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon",attrs:{"type":"button"},on:{"click":function($event){_vm.openDeleteMedia = media}}},[_c('i',{staticClass:"icon-trash"})])]):_vm._e()])}),0)])]):_c('div',[(_vm.image)?_c('div',[_c('img',{staticClass:"img-thumbnail img-rounded",attrs:{"src":_vm._f("media")(_vm.media,'admin-preview'),"alt":_vm.media.alt || _vm.media.name}}),_vm._v(" "),_c('p',{staticClass:"no-margin text-overflow text-center"},[_c('strong',[_vm._v(_vm._s(_vm.media.name))]),_c('br'),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm._f("filesize")(_vm.media.length)))])])]):_c('span',[_vm._v("Fichier sélectionné : "),_c('strong',[_vm._v(_vm._s(_vm.media.name))])])])])]})],2):_vm._e(),_vm._v(" "),_c('div',[_c('form-upload',{attrs:{"disabled":!!_vm.loading,"process-upload":_vm.processUpload,"browse-label":"Parcourir...","empty-label":_vm.multiple? 'Envoyer des fichiers...': 'Envoyer un fichier',"multiple":_vm.multiple}})],1),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.error),expression:"error"}],staticClass:"error"},[_vm._v(_vm._s(_vm.error))]),_vm._v(" "),(_vm.openEditMedia)?_c('modal',{attrs:{"title":("Édition " + (_vm.image ? 'de l\'image': 'du fichier') + " " + (_vm.openEditMedia.name)),"size":"sm"},on:{"close":function($event){_vm.openEditMedia = null}}},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.image),expression:"image"}]},[_vm._v("Sélectionner la nouvelle image pour remplacer "),_c('strong',[_vm._v(_vm._s(_vm.openEditMedia.name))]),_vm._v("…")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.image),expression:"!image"}]},[_vm._v("Sélectionner le nouveau fichier pour remplacer "),_c('strong',[_vm._v(_vm._s(_vm.openEditMedia.name))]),_vm._v("…")]),_vm._v(" "),_c('form-upload',{attrs:{"disabled":!!_vm.loading,"process-upload":_vm.processUploadMedia,"browse-label":"Parcourir...","empty-label":"Envoyer un fichier"}})],1):_vm._e(),_vm._v(" "),(_vm.openDeleteMedia)?_c('modal',{attrs:{"title":("Suppression " + (_vm.image? 'de l\'image': 'du fichier') + " " + (_vm.openDeleteMedia.name)),"size":"sm"},on:{"close":function($event){_vm.openDeleteMedia = null}}},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.image),expression:"image"}]},[_vm._v("Voulez-vous supprimer définitivement l'image "),_c('strong',[_vm._v(_vm._s(_vm.openDeleteMedia.name))]),_vm._v(" partout où elle est utilisée ?")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.image),expression:"!image"}]},[_vm._v("Voulez-vous supprimer définitivement le fichier "),_c('strong',[_vm._v(_vm._s(_vm.openDeleteMedia.name))]),_vm._v(" partout où il est utilisé ?")]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning",attrs:{"type":"button"},on:{"click":_vm.processDeleteMedia}},[_vm._v("Je confirme la suppression")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 694:
/*!***************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a3f0ab9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormOrder.vue ***!
  \***************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-input',{attrs:{"type":"range","min":"1","max":"1OO","disabled":_vm.disabled,"required":_vm.required},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}),_vm._v(" "),_c('div',{attrs:{"slot":"help"},slot:"help"},[_c('span',{staticClass:"pull-right text-muted"},[_vm._v("Position : "+_vm._s(_vm.model))]),_vm._v(" "),(_vm.model == 100)?_c('span',{staticClass:"text-muted"},[_vm._v("En dernier")]):(_vm.model == 1)?_c('span',{staticClass:"text-orange text-semibold"},[_vm._v("En premier")]):(_vm.model >= 67)?_c('span',{staticClass:"text-slate"},[_vm._v("Vers la fin")]):(_vm.model <= 33)?_c('span',{staticClass:"text-green-700 text-semibold"},[_vm._v("Vers le début")]):_c('span',{staticClass:"text-blue-600"},[_vm._v("Vers le milieu")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 695:
/*!**************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42709f1f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activity.vue ***!
  \**************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"no-margin"},[_vm._v("Créé "+_vm._s(_vm._f("ago")(_vm.value.createdAt)))]),_vm._v(" "),_c('p',{staticClass:"no-margin text-size-small text-muted"},[_vm._v("Modifié "+_vm._s(_vm._f("ago")(_vm.value.updatedAt)))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 696:
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3df2c514","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ColorBadge.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 697:
/*!****************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3df2c514","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ColorBadge.vue ***!
  \****************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"Color",style:({width: _vm.width, height: _vm.width})},[_c('span',{staticClass:"MainColor",style:({background: _vm.color && _vm.color.colors && _vm.color.colors[0] || '#fff'})}),_vm._v(" "),(_vm.color && _vm.color.kind === 'duo')?_c('span',{staticClass:"DuoColor",style:({'border-bottom-color': _vm.color && _vm.color.colors && _vm.color.colors[1] || '#fff', 'border-width': ("0 0 " + _vm.width + " " + _vm.width)})}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 699:
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c64ae0a8","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/FormSelectColor.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 703:
/*!****************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22de0688","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OptionHtml.vue ***!
  \****************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('option',{ref:"option",domProps:{"value":_vm.value}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 704:
/*!*********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c64ae0a8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormSelectColor.vue ***!
  \*********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("form-multiselect",_vm._b({tag:"select",attrs:{"html":"","select-all":"","placeholder":_vm.placeholder,"required":_vm.required,"parameters":_vm.parameters},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'select',_vm.$attrs,false),[(!_vm.required)?_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),_vm._l((_vm.colorsByGroup),function(options,groupName){return _c('optgroup',{key:groupName,attrs:{"label":groupName || '(aucun groupe)'}},_vm._l((options),function(option){return _c('option-html',{key:option.id,attrs:{"value":option.id}},[_c('div',{staticClass:"pull-left mr-5 valign-middle"},[_c('color-badge',{attrs:{"color":option,"size":"mini"}})],1),_vm._v(" "),_c('div',{staticClass:"valign-middle text-default"},[_vm._v(_vm._s(option.name))])])}),1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 705:
/*!****************************!*\
  !*** ./src/store/index.js ***!
  \****************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/toConsumableArray */ 131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/extends */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(/*! vuex */ 410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(/*! vue */ 356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_categoriesModule__ = __webpack_require__(/*! ./modules/categoriesModule */ 706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_collectionsModule__ = __webpack_require__(/*! ./modules/collectionsModule */ 707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_colorsModule__ = __webpack_require__(/*! ./modules/colorsModule */ 708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_productsModule__ = __webpack_require__(/*! ./modules/productsModule */ 709);










__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  modules: {
    categories: __WEBPACK_IMPORTED_MODULE_4__modules_categoriesModule__["a" /* default */],
    collections: __WEBPACK_IMPORTED_MODULE_5__modules_collectionsModule__["a" /* default */],
    colors: __WEBPACK_IMPORTED_MODULE_6__modules_colorsModule__["a" /* default */],
    products: __WEBPACK_IMPORTED_MODULE_7__modules_productsModule__["a" /* default */]
  },
  state: {
    user: null,
    notificationsId: 0,
    notifications: []
  },
  mutations: {
    setUser: function setUser(state, user) {
      state.user = user;
    },
    addNotification: function addNotification(state, notification) {
      var notificationWithId = __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, notification, {
        id: notification.id || state.notificationsId++
      });
      state.notifications = [].concat(__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_toConsumableArray___default()(state.notifications.filter(function (n) {
        return notification.id !== n.id;
      })), [notificationWithId]);
      return notificationWithId.id;
    },
    removeNotification: function removeNotification(state, _ref) {
      var id = _ref.id;

      state.notifications = state.notifications.filter(function (notification) {
        return notification.id !== id;
      });
    }
  },
  actions: {
    setUser: function setUser(_ref2, user) {
      var commit = _ref2.commit;

      return commit('setUser', user);
    },
    unsetUser: function unsetUser(_ref3) {
      var commit = _ref3.commit;

      return commit('setUser', null);
    },
    addNotification: function addNotification(_ref4, notification) {
      var commit = _ref4.commit;

      return commit('addNotification', notification);
    },
    addNotificationError: function addNotificationError(_ref5, text) {
      var commit = _ref5.commit;

      console.error(text);
      return commit('addNotification', {
        text: text,
        type: 'warning',
        className: 'bg-warning'
      });
    },
    addNotificationSuccess: function addNotificationSuccess(_ref6, text) {
      var commit = _ref6.commit;

      return commit('addNotification', {
        text: text,
        type: 'success'
      });
    },
    removeNotification: function removeNotification(_ref7, notification) {
      var commit = _ref7.commit;

      return commit('removeNotification', notification);
    }
  }
}));

/***/ }),

/***/ 706:
/*!***********************************************!*\
  !*** ./src/store/modules/categoriesModule.js ***!
  \***********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/extends */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends__);

var initialFilterState = {
  search: ''
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    filter: __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, initialFilterState),
    pagination: {
      offset: 0,
      limit: 10
    }
  },
  mutations: {
    setFilter: function setFilter(state, value) {
      state.filter = value;
      state.pagination.offset = 0;
    },
    setPagination: function setPagination(state, value) {
      state.pagination = value;
    },
    resetFilter: function resetFilter(state) {
      state.filter = __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, initialFilterState);
    }
  },
  actions: {
    setPagination: function setPagination(_ref, value) {
      var commit = _ref.commit;

      return commit('setPagination', value);
    },
    setFilterSearch: function setFilterSearch(_ref2, search) {
      var commit = _ref2.commit,
          state = _ref2.state;

      return commit('setFilter', __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, state.filter, { search: search }));
    },
    resetFilter: function resetFilter(_ref3) {
      var commit = _ref3.commit;

      return commit('resetFilter');
    }
  }
});

/***/ }),

/***/ 707:
/*!************************************************!*\
  !*** ./src/store/modules/collectionsModule.js ***!
  \************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/extends */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends__);

var initialFilterState = {
  search: '',
  category: null
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    filter: __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, initialFilterState),
    pagination: {
      offset: 0,
      limit: 10
    }
  },
  mutations: {
    setFilter: function setFilter(state, value) {
      state.filter = value;
      state.pagination.offset = 0;
    },
    setPagination: function setPagination(state, value) {
      state.pagination = value;
    },
    resetFilter: function resetFilter(state) {
      state.filter = initialFilterState;
    }
  },
  actions: {
    setPagination: function setPagination(_ref, value) {
      var commit = _ref.commit;

      return commit('setPagination', value);
    },
    setFilterSearch: function setFilterSearch(_ref2, search) {
      var commit = _ref2.commit,
          state = _ref2.state;

      return commit('setFilter', __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, state.filter, { search: search }));
    },
    setFilterCategory: function setFilterCategory(_ref3, category) {
      var commit = _ref3.commit,
          state = _ref3.state;

      return commit('setFilter', __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, state.filter, { category: category }));
    },
    resetFilter: function resetFilter(_ref4) {
      var commit = _ref4.commit;

      return commit('resetFilter');
    }
  }
});

/***/ }),

/***/ 708:
/*!*******************************************!*\
  !*** ./src/store/modules/colorsModule.js ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/extends */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends__);

var initialFilterState = {
  search: '',
  group: null
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    filter: __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, initialFilterState),
    pagination: {
      offset: 0,
      limit: 12
    }
  },
  mutations: {
    setFilter: function setFilter(state, value) {
      state.filter = value;
      state.pagination.offset = 0;
    },
    setPagination: function setPagination(state, value) {
      state.pagination = value;
    },
    resetFilter: function resetFilter(state) {
      state.filter = initialFilterState;
    }
  },
  actions: {
    setPagination: function setPagination(_ref, value) {
      var commit = _ref.commit;

      return commit('setPagination', value);
    },
    setFilterSearch: function setFilterSearch(_ref2, search) {
      var commit = _ref2.commit,
          state = _ref2.state;

      return commit('setFilter', __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, state.filter, { search: search }));
    },
    setFilterGroup: function setFilterGroup(_ref3, group) {
      var commit = _ref3.commit,
          state = _ref3.state;

      return commit('setFilter', __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, state.filter, { group: group }));
    },
    resetFilter: function resetFilter(_ref4) {
      var commit = _ref4.commit;

      return commit('resetFilter');
    }
  }
});

/***/ }),

/***/ 709:
/*!*********************************************!*\
  !*** ./src/store/modules/productsModule.js ***!
  \*********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/extends */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends__);

var initialFilterState = {
  search: '',
  kind: null,
  collection: null
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    filter: __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, initialFilterState),
    pagination: {
      offset: 0,
      limit: 10
    }
  },
  mutations: {
    setFilter: function setFilter(state, value) {
      state.filter = value;
      state.pagination.offset = 0;
    },
    setPagination: function setPagination(state, value) {
      state.pagination = value;
    },
    resetFilter: function resetFilter(state) {
      state.filter = initialFilterState;
    }
  },
  actions: {
    setPagination: function setPagination(_ref, value) {
      var commit = _ref.commit;

      return commit('setPagination', value);
    },
    setFilterSearch: function setFilterSearch(_ref2, search) {
      var commit = _ref2.commit,
          state = _ref2.state;

      return commit('setFilter', __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, state.filter, { search: search }));
    },
    setFilterKind: function setFilterKind(_ref3, kind) {
      var commit = _ref3.commit,
          state = _ref3.state;

      return commit('setFilter', __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, state.filter, { kind: kind }));
    },
    setFilterCollection: function setFilterCollection(_ref4, collection) {
      var commit = _ref4.commit,
          state = _ref4.state;

      return commit('setFilter', __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, state.filter, { collection: collection }));
    },
    resetFilter: function resetFilter(_ref5) {
      var commit = _ref5.commit;

      return commit('resetFilter');
    }
  }
});

/***/ }),

/***/ 710:
/*!*******************************!*\
  !*** ./src/components \.vue$ ***!
  \*******************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Activity.vue": 416,
	"./App.vue": 143,
	"./ColorBadge.vue": 135,
	"./FormFileUpload.vue": 403,
	"./FormOrder.vue": 405,
	"./FormSelectColor.vue": 414,
	"./FormStickyHeader.vue": 396,
	"./LayoutSignedIn.vue": 296,
	"./LayoutSignedOut.vue": 351,
	"./MediaImage.vue": 409,
	"./OptionHtml.vue": 142,
	"./PublishingStatus.vue": 411
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 710;

/***/ }),

/***/ 78:
/*!*********************************!*\
  !*** ./src/mixins/app-mixin.js ***!
  \*********************************/
/*! exports provided: AppMixin */
/*! exports used: AppMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppMixin; });
var AppMixin = {
  computed: {
    pageTitle: function pageTitle() {
      return this.$route.meta && this.$route.meta.title || this.$route.name;
    }
  }
};

/***/ })

},[421]);


// WEBPACK FOOTER //
// client.f917ac84.js